import RowItem from "../../molecules/RowItem";
import OptionTitle from "../../atoms/OptionTitle";
import Button from "../../atoms/Button";
import React, { useState } from "react";
import styled from "styled-components";
import Conditional from "../../atoms/Conditional";
import Flex from "../../atoms/Flex";
import EditIcon from "@material-ui/icons/Edit";
import { useMediaQuery } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { Launch } from "@material-ui/icons";

const Styled = styled.div`
  width: 100%;
  padding: 8px;
  background-color: ${(p) => p.color};
  border-radius: 4px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);
  position: relative;

  & > .removeButton {
    width: 16px;
    height: 16px;
    position: absolute;
    z-index: 100;
    top: 8px;
    opacity: 0.5;
    right: 8px;
    cursor: pointer;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(data:image/svg+xml;base64,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);
    border-radius: 100px;
    font-size: 16px;

    &:hover {
      opacity: 0.8;
    }
  }

  & .sponsoredLink {
    position: relative;
  }

  & .sponsoredLabel {
    font-size: 10px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 30px);
  }
`;

const StyledThumbnail = styled.div`
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: space-evenly;
  & > img {
    height: 100%;
    width: calc(100% / ${(el) => el.imageCount});
  }
`;

const renderSelectedYarnLabel = (yarnsCount, t) => {
  return (
    t("yarnDrawer.selectedYarnSummaryLabel") +
    yarnsCount +
    (yarnsCount > 1
      ? t("yarnDrawer.selectedYarnMulti")
      : t("yarnDrawer.selectedYarnSingle"))
  );
};

const renderThumbnail = (srcs) => {
  return (
    <StyledThumbnail imageCount={srcs.length}>
      {srcs.map((el) => (
        <img src={el} />
      ))}
    </StyledThumbnail>
  );
};

const renderBuylinks = (links, anchorEl, handleClose) => {
  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      {links.map((el, i) => {
        return (
          <a href={el.buyLink} target={"_blank"} rel={"noopener"}>
            <MenuItem key={`buylink-${i}`} style={{ fontFamily: "inherit" }}>
              {el.name}
              <Launch fontSize={"inherit"} style={{ marginLeft: 8 }} />
            </MenuItem>
          </a>
        );
      })}
    </Menu>
  );
};

const YarnSelectedCard = ({
  handleClearSelected,
  handleEditClick,
  imageUrls,
  title,
  urls,
  count = 1,
  color = "transparent",
}) => {
  const isMobile = useMediaQuery("(max-width:699px)");

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClickBuy = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);
  const { t } = useTranslation();

  return (
    <Styled color={color}>
      <Conditional when={Boolean(handleClearSelected)}>
        <div onClick={handleClearSelected} className={"removeButton"} />
      </Conditional>
      <RowItem
        style={{ maxWidth: "100%" }}
        imageSrc={renderThumbnail(imageUrls)}
        allowEdit={Boolean(handleEditClick) && !isMobile}
        handleClick={handleEditClick}
        editButtonLabel={t("buttons.change")}
      >
        <OptionTitle title={title} />

        <p style={{ margin: "2px 0 2px 0" }}>
          {renderSelectedYarnLabel(count, t)}
        </p>
        <Flex alignX={"flex-start"}>
          <a
            href={urls.length === 1 ? urls[0]?.buyLink : null}
            target={"_blank"}
            className={"sponsoredLink"}
            rel={"noopener"}
          >
            <Button
              style={{ width: "100%", whiteSpace: "nowrap" }}
              label={t("buttons.buyOnline")}
              size={"small"}
              handleClick={urls.length > 1 ? handleClickBuy : null}
            />
            <label className={"sponsoredLabel"}>
              {t("utils.sponsoredLink")}
            </label>
          </a>
          <Conditional when={urls?.length > 1}>
            {renderBuylinks(urls, anchorEl, handleClose)}
          </Conditional>
          <Conditional when={Boolean(handleEditClick) && isMobile}>
            <Button
              size={"small"}
              style={{ marginLeft: 4 }}
              handleClick={handleEditClick}
            >
              <EditIcon style={{ marginRight: 4 }} fontSize={"inherit"} />
              {t("buttons.change")}
            </Button>
          </Conditional>
        </Flex>
      </RowItem>
    </Styled>
  );
};

export default YarnSelectedCard;
